module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAS0lEQVQ4y2NgIAJk5Rdtzcov3MJADdDQ0MCUmVf4H2jo31EDRw2klYGgRAvSQA0MMovKBhKRm0ZjedTAwWAgODflFW3PyivcRIxaAJjWwwVN9GkSAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./resources/images/plus_2x.png
// module id = 1006
// module chunks = 0